setTimeout(() => {
    let a = document.querySelector('button[name="checkout"]')
    if (a) {
        a.addEventListener("click", (e) => {
            let oldText = e.target.innerText
            console.log(e.target)
            e.target.innerText = "loading"
            setTimeout(() => {
                e.target.innerText = oldText
            }, 1000)
        })
    }

    function addEventCheckout() {
        let buttonQuantity = document.querySelectorAll('quantity-component quantity-btn')
        if (buttonQuantity.length) {
            buttonQuantity.forEach((e) => {
                addEventListener('click', () => {
                    setTimeout(() => {
                        BSS_B2B.observer.cartSubject.listenCartCheckout();
                    }, 2000)
                })
            })
        }
        let inputQuantity = document.querySelector('.cart-item-quantity__input')
        inputQuantity.addEventListener('change', () => {
            setTimeout(() => {
                BSS_B2B.observer.cartSubject.listenCartCheckout();
            }, 2000)
        })
    }
    addEventCheckout()

}, 1500)